var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008DE4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.9,
    r: 440.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.4,195.1H314l-18.3,102.5l199.8,0.3c98.4,0,127.5,35.7,126.7,95c-0.5,30.4-13.6,81.8-19.3,98.4 c-15.2,44.3-46.3,95-163.1,94.9L245.6,586l-18.4,102.6h220.9c77.9,0,111-9.1,146.1-25.3c77.8-35.9,124.1-112.7,142.7-212.9 C764.4,301.3,730,195.1,535.4,195.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.5,390.4c-58,0-66.3,37.8-71.8,60.6c-7.2,29.9-9.5,42-9.5,42h226.7c58,0,66.3-37.8,71.8-60.6 c7.2-29.9,9.5-42,9.5-42H218.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dash_icon.daa4eeb30588dc706663715af564bf22.svg";
export { ForwardRef as ReactComponent };